import axios from '../../axiosConfig'
import { tokenConfig } from '../auth'
import {
  FETCH_EX_GRUPOS_PERFILES,
  FETCH_MAS_GRUPOS,
  GET_EX_GRUPOS_PERFILES,
  GET_MAS_GRUPOS,
  SET_BUSQUEDA_GRUPO,
  SET_EX_GRUPO_SELECCIONADO,
  UNSET_EX_GRUPO_SELECCIONADO,
} from '../types'

// GET EX GRUPOS PERFILES
export const getExGrupos =
  (search = '', paginar = 'N') =>
  (dispatch, getState) => {
    dispatch({
      type: FETCH_EX_GRUPOS_PERFILES,
    })

    let config = tokenConfig(getState)

    axios
      .get(`/exGrupos/?search=${search}&paginar=${paginar}`, config)
      .then(res => {
        dispatch({
          type: GET_EX_GRUPOS_PERFILES,
          payload: res.data,
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

// GET MÁS GRUPOS
export const getMasGrupos =
  (url, limit = 15) =>
  (dispatch, getState) => {
    dispatch({
      type: FETCH_MAS_GRUPOS,
    })

    if (url == null || url === '') {
      url = `/exGrupos/?search=&paginar=S&limit=${limit}`
    } else {
      if (url.startsWith('http://')) {
        url = url.replace('http://', 'https://')
      }
    }

    axios
      .get(url, tokenConfig(getState))
      .then(res => {
        dispatch({
          type: GET_MAS_GRUPOS,
          payload: res.data,
        })
      })
      .catch(err => console.log(err))
  }

export const setBusquedaGrupo = search => (dispatch, getState) => {
  dispatch({
    type: SET_BUSQUEDA_GRUPO,
    payload: search,
  })
}

export const setExGrupoSeleccionado = (codigo, nombre) => (dispatch, getState) => {
  dispatch({
    type: SET_EX_GRUPO_SELECCIONADO,
    payload: codigo,
  })
}

export const unsetExGrupoSeleccionado = () => (dispatch, getState) => {
  dispatch({
    type: UNSET_EX_GRUPO_SELECCIONADO,
  })
}
